import { useEffect } from "react";
import { useLocation } from "@gatsbyjs/reach-router";

// CSS background images have no native equivalent to `<img loading="lazy">`,
// so we still hydrate `[data-bg]` via IntersectionObserver for below-the-fold
// decorative backgrounds. `<img>` lazy-loading is handled natively via the
// `loading="lazy"` attribute — this hook no longer touches `data-src`.
function useLazyLoad(rootMargin = "200px") {
    const location = useLocation();

    useEffect(() => {
        const lazyElements = document.querySelectorAll("[data-bg]");
        if (lazyElements.length === 0) return;

        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    const element = entry.target;
                    const bg = element.getAttribute("data-bg");
                    if (bg) {
                        element.style.backgroundImage = `url("${bg}")`;
                        element.removeAttribute("data-bg");
                    }
                    obs.unobserve(element);
                });
            },
            { rootMargin }
        );

        lazyElements.forEach((element) => observer.observe(element));

        return () => observer.disconnect();
    }, [rootMargin, location.pathname]);
}


export default useLazyLoad
